import { Injectable } from '@angular/core';

import { OccOrderNormalizer } from '@spartacus/order/occ';
import { ConverterService } from '@spartacus/core';

import { CustomProductImageNormalizer } from './custom-product-image-normalizer.service';
import { CustomOrder, OccCustomOrder } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CustomOrderNormalizer extends OccOrderNormalizer {
  constructor(
    protected superConverter: ConverterService,
    private productImageNormalizer: CustomProductImageNormalizer
  ) {
    super(superConverter);
  }
  convert(source: OccCustomOrder, target?: CustomOrder): CustomOrder {
    target = super.convert(source, target) as CustomOrder;
    target.entryGroups = source?.entryGroups?.map((group) => ({
      ...group,
      medias: this.productImageNormalizer.normalize(group.medias),
      entries: group.entries?.map((entry) => ({
        ...entry,
        product: this.productImageNormalizer.convert(entry.product)
      }))
    }));
    return target;
  }
}
